<app-navbar title="Acesso não autorizado" />

<div class="container m-auto py-8 px-4 flex items-center justify-center overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)]">
  <app-card class="w-full max-w-2xl">
    <div class="flex flex-col items-start justify-start gap-2">
      <div>
        <p-message severity="contrast" size="small">403</p-message>
      </div>
      <div class="text-zinc-900 text-3xl font-semibold my-8">Acesso não autorizado</div>
      <div class="text-zinc-500">Desculpe, mas seu perfil de usuário não permite acessar essa página, entre em contato com o seu gestor</div>
      <p-divider />
      <p-panelmenu [model]="menuItems" class="w-full">
        <ng-template #item let-item>
          <a
            class="flex items-center px-4 py-2 cursor-pointer group bg-zinc-50/0 hover:bg-zinc-50 transition-colors duration-200 ease-in-out"
            (click)="item.action()"
          >
            <i [class]="item.icon + ' text-zinc-900'"></i>
            <span class="ml-2 text-zinc-900">
              {{ item.label }}
            </span>
          </a>
        </ng-template>
      </p-panelmenu>
    </div>
  </app-card>
</div>
